/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, Fragment, useRef } from 'react';
import smallPlus from '../assets/images/model/small_plus.svg';
import plus from '../images/plus_color.svg';
import { useSelector } from 'react-redux';
import Option from './Option';
import FreeResponse from './FreeResponse';
import FillBlanksOption from './activity/FillBlanksOption';
import MultipleChoiceOpions from './MultipleChoiceOpions';
import TrueAndFalse from './TureAndFalse';
import ActivityMedia from './ActivityMedia';
import MediaComponent from './activity/MediaComponent';
const NewQuestion = ({
  question,
  setDifficulty,
  index,
  activity,
  actIndex,
  editQuestion,
  editQuestionScore,
  types,
  setQuestions,
  activityScore,
  closeQuestion,
  mode,
  editing,
  deleteQuestion,
  setNewActivities,
  handleQuestionLevelMedia = () => {},
}) => {
  const { user } = useSelector((state) => state.auth);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedOption, setSelectedOption] = useState('text');
  const [isTotalBlanks, setIsTotalBlanks] = useState();
  const [isMore, setIsMore] = useState(true);
  const [optionTypes, setOptionTypes] = useState(['text', 'image', 'audio', 'video']);
  const [openMedia, setOpenMedia] = useState(false);
  const [mediaList, setMediaList] = useState([]);

  const elRef = useRef(null);
  const defaultOptions = {
    type: 'truefalse',
    options: [
      {
        type: 'text',
        text: 'True',
        isCorrect: false,
      },
      {
        type: 'text',
        text: 'False',
        isCorrect: false,
      },
    ],
  };

  const autoResize = (e) => {
    e.target.style.height = '22px'; // Reset the height initially
    e.target.style.height = `${e.target.scrollHeight}px`; // Adjust height based on content
  };

  const handleMediaUpload = (fileUrl, mediaIndex) => {
    setMediaList((prev) =>
      prev.map((item, i) => (i === mediaIndex ? { ...item, url: fileUrl } : item))
    );
    handleQuestionLevelMedia(fileUrl, index, mediaIndex);
  };
  const setDesc = (e) => {
    setNewActivities((old) =>
      old.map((activity, actIdx) =>
        actIdx !== actIndex
          ? activity
          : {
              ...activity,
              questions: activity.questions.map((q, qIdx) =>
                qIdx !== index
                  ? q
                  : {
                      ...q,
                      description: e.target.value,
                    }
              ),
            }
      )
    );
  };

  return (
    <div key={index}>
      <div className='edit-act-question-top-nav mb-0'>
        <h5>{types[question.type]}</h5>
        {editing && (
          <ul>
            <li>
              <a
                className='edit-activity-question-delete cursor'
                onClick={(e) => {
                  deleteQuestion(index);
                }}
              >
                delete
              </a>
            </li>
            <li>
              <a
                className='edit-activity-question-edit cursor'
                onClick={(e) => {
                  setIsEditing(true);
                }}
              >
                {isEditing ? 'editing' : 'edit'}
              </a>
            </li>
          </ul>
        )}
      </div>

      <Fragment>
        <div className='Multiple_choice_body'>
          <textarea
            type='text'
            style={{
              resize: 'none',
              lineHeight: question.type === 'fr' && question.type === 'sa' ? '8px' : '20px',
            }}
            className='questioninput '
            placeholder='Ask a question'
            name='text'
            value={question.text}
            readOnly={!editing}
            ref={(el) => (el ? autoResize({ target: el }) : null)}
            onChange={(e) => {
              editQuestion(e, index);
              autoResize(e);
            }}
          />
          {/* <MediaComponent media={activity} /> */}
          {isEditing ? (
            <Fragment>
              <div className='description-input-wrapper'>
                {activity.createdBy === user._id && (
                  <img
                    src={plus}
                    alt='plus'
                    style={{ display: 'flex', alignSelf: 'flex-start' }}
                  />
                )}
                {(question.description || activity.createdBy === user._id) && (
                  <textarea
                    type='text'
                    readOnly={!editing}
                    style={{
                      resize: 'none',
                    }}
                    className='activity-description-input'
                    name='description'
                    value={question.description}
                    onChange={(e) => {
                      editQuestion(e, index);
                      autoResize(e);
                    }}
                    placeholder='Write instructions or use plus for media (optional)'
                    ref={(el) => (el ? autoResize({ target: el }) : null)}
                  />
                )}
              </div>
              {/* <ActivityMedia
                handleMediaUpload={handleMediaUpload}
                setOpenMedia={setOpenMedia}
                setMediaList={setMediaList}
                openMedia={openMedia}
                mediaList={
                  question.questionMedia
                    ? question.questionMedia
                    : question.questionMediaTypeUrl
                    ? [
                        {
                          type: question.questionInstructionsType,
                          url: question.questionMediaTypeUrl,
                        },
                      ]
                    : []
                }
                activity={question.description}
                setDesc={setDesc}
                elRef={elRef}
              /> */}
              <MediaComponent
                media={{
                  url: activity.questions[index]?.questionMediaTypeUrl || '',
                  type: activity.questions[index]?.questionInstructionsType || 'text',
                }}
                level='question'
              />

              <div className='edit-act-question-top-nav '>
                <div
                  style={{
                    display: 'flex',
                    width: '32.5%',
                    justifyContent: 'space-between',
                  }}
                >
                  <span className='points-label'>
                    {Math.round((question.score / activityScore) * 100)}%
                  </span>
                  <div
                    style={{
                      display: 'flex',
                      width: '67%',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div
                      onClick={() => {
                        setDifficulty(index, 1);
                      }}
                      style={{
                        width: '30px',
                        height: '15px',
                        borderRadius: '6px 0px 0px 6px',
                        border: '0.5px solid var(--Grey-700, #76736F)',
                        cursor: 'pointer',
                        background: `${
                          question.difficulty === 1 || !question.difficulty
                            ? '#0A5C59'
                            : question.difficulty === 2
                            ? '#FFBF00'
                            : '#AE2604'
                        }`,
                      }}
                    ></div>
                    <div
                      onClick={() => {
                        setDifficulty(index, 2);
                      }}
                      style={{
                        width: '30px',
                        height: '15px',
                        border: '0.5px solid var(--Grey-700, #76736F)',
                        cursor: 'pointer',
                        background: `${
                          question.difficulty === 2
                            ? '#FFBF00'
                            : question.difficulty === 3
                            ? '#AE2604'
                            : '#D2CFCB'
                        }`,
                      }}
                    ></div>
                    <div
                      onClick={() => {
                        setDifficulty(index, 3);
                      }}
                      style={{
                        width: '30px',
                        height: '15px',
                        borderRadius: '0px 6px 6px 0px',
                        border: '0.5px solid var(--Grey-700, #76736F)',
                        cursor: 'pointer',
                        background: `${question.difficulty === 3 ? '#AE2604' : '#D2CFCB'}`,
                      }}
                    ></div>
                  </div>
                </div>
                <ul>
                  <li>
                    <a
                      className='edit-activity-question-view-more cursor'
                      onClick={() => setIsMore((old) => !old)}
                    >
                      {isMore ? 'hide answers' : 'show answers'}
                    </a>
                  </li>
                </ul>
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <MediaComponent
                media={{
                  url: activity.questions[index]?.questionMediaTypeUrl || '',
                  type: activity.questions[index]?.questionInstructionsType || 'text',
                }}
                level='question'
              />

              <div className='edit-act-question-top-nav '>
                <span className='points_answer'>
                  <b>{Math.round((question.score / activityScore) * 100)}%</b>{' '}
                  {question.type === 'fr' || question.type === 'sa' ? (
                    ''
                  ) : (
                    <span style={{ fontSize: '22px' }}>| </span>
                  )}
                  {question.type === 'fr' || question.type === 'sa'
                    ? ''
                    : question.type === 'blanks'
                    ? question.blanksBank.length
                    : question.options.length}{' '}
                  {question.type === 'blanks'
                    ? 'blanks'
                    : ['mcqs', 'truefalse'].includes(question.type)
                    ? 'answers'
                    : ''}
                  <div
                    style={{
                      height: '10px',
                      width: '30px',
                      display: 'inline-block',
                      marginLeft: '12px',
                      borderRadius: '15px',
                      background: `${
                        question.difficulty === 1
                          ? '#0A5C59'
                          : question.difficulty === 2
                          ? '#FFBF00'
                          : '#AE2604'
                      }`,
                    }}
                  ></div>
                </span>
                <ul>
                  <li>
                    <a
                      className='edit-activity-question-view-more cursor'
                      onClick={() => setIsMore((old) => !old)}
                    >
                      {isMore ? 'hide answers' : 'show answers'}
                    </a>
                  </li>
                </ul>
              </div>
            </Fragment>
          )}

          <div className='input_choice'>
            {question.options && Array.isArray(question.options) && (
              <Fragment>
                {isMore && !isEditing ? (
                  <MultipleChoiceOpions
                    question={question}
                    index={index}
                    setQuestionMultiple={setQuestions}
                    isEditing={isEditing}
                    isMore={isMore}
                    setQuestions={setQuestions}
                  />
                ) : (
                  <Fragment>
                    <>
                      {question.options.map((option, optionIndex) => (
                        <Fragment>
                          <Option
                            option={option}
                            optionIndex={optionIndex}
                            index={index}
                            setQuestions={setQuestions}
                            editing={editing}
                            isMore={isMore}
                            question={question}
                            defaultOptions={defaultOptions}
                          />
                        </Fragment>
                      ))}
                    </>
                  </Fragment>
                )}
              </Fragment>
            )}

            {/* {question.type === "truefalse" && (
              <>
                <TrueAndFalse
                  isEditing={isEditing}
                  question={question}
                  setQuestions={setQuestions}
                  editQuestion={editQuestion}
                  questionIndex={index}
                />
              </>
            )} */}

            {question.type === 'blanks' && (
              <Fragment>
                <FillBlanksOption
                  setIsEditing={setIsEditing}
                  isEditing={isEditing}
                  index={index}
                  isMore={isMore}
                  question={question}
                  setQuestions={setQuestions}
                  setIsTotalBlanks={setIsTotalBlanks}
                  editing={editing}
                  activity={activity}
                  mode={mode}
                />
              </Fragment>
            )}
            {['fr', 'sa'].includes(question.type) && (
              <FreeResponse
                setIsEditing={setIsEditing}
                isEditing={isEditing}
                index={index}
                isMore={isMore}
                question={question}
                setQuestions={setQuestions}
                setIsTotalBlanks={setIsTotalBlanks}
              />
            )}

            {['orderlist', 'mcqs', 'matching', 'multiselect'].includes(question.type) &&
            Array.isArray(question.options) &&
            question.options.length < 6 ? (
              <Fragment>
                {editing && (
                  <div
                    className='option-adder-wrapper'
                    style={{ justifyContent: 'space-between' }}
                  >
                    <div className='Multiplechoice_wrap'>
                      <div className='btn-group' style={{ alignItems: 'center' }}>
                        <img
                          src={smallPlus}
                          alt='plus'
                          className='mr-3 cursor'
                          style={{ paddingRight: '5px' }}
                          onClick={(e) => {
                            setQuestions((old) => {
                              return {
                                ...old,
                                questions: old.questions.map((que, i) =>
                                  i === index
                                    ? {
                                        ...que,
                                        options: [
                                          ...que.options,
                                          {
                                            text: '',
                                            type: que.options.length
                                              ? que.options[0].type
                                              : 'text',
                                            isCorrect: false,
                                          },
                                        ],
                                      }
                                    : que
                                ),
                              };
                            });
                            setSelectedOption('image');
                            setOptionTypes('image');
                          }}
                        />
                        Add
                        <button
                          type='button'
                          className='btn btn-link dropdown-toggle'
                          data-bs-toggle='dropdown'
                          aria-expanded='false'
                          style={{ margin: '0 4px' }}
                        >
                          {selectedOption || 'option'}
                        </button>
                        option
                        <ul className='dropdown-menu cursor'>
                          {optionTypes.includes('text') && (
                            <li>
                              <a
                                className='dropdown-item cursor'
                                onClick={(e) => {
                                  setQuestions((old) => {
                                    return {
                                      ...old,
                                      questions: old.questions.map((que, i) =>
                                        i === index
                                          ? {
                                              ...que,
                                              options: [
                                                ...que.options,
                                                {
                                                  text: '',
                                                  type: 'text',
                                                  isCorrect: false,
                                                },
                                              ],
                                            }
                                          : que
                                      ),
                                    };
                                  });
                                  setSelectedOption('text');
                                  setOptionTypes('text');
                                }}
                              >
                                text
                              </a>
                            </li>
                          )}
                          {optionTypes.includes('image') && (
                            <li>
                              <a
                                className='dropdown-item cursor'
                                onClick={(e) => {
                                  setQuestions((old) => {
                                    return {
                                      ...old,
                                      questions: old.questions.map((que, i) =>
                                        i === index
                                          ? {
                                              ...que,
                                              options: [
                                                ...que.options,
                                                {
                                                  text: '',
                                                  type: 'image',
                                                  isCorrect: false,
                                                },
                                              ],
                                            }
                                          : que
                                      ),
                                    };
                                  });
                                  setSelectedOption('image');
                                  setOptionTypes('image');
                                }}
                              >
                                image
                              </a>
                            </li>
                          )}
                          {optionTypes.includes('video') && (
                            <li>
                              <a
                                className='dropdown-item cursor'
                                onClick={(e) => {
                                  setQuestions((old) => {
                                    return {
                                      ...old,
                                      questions: old.questions.map((que, i) =>
                                        i === index
                                          ? {
                                              ...que,
                                              options: [
                                                ...que.options,
                                                {
                                                  text: '',
                                                  type: 'video',
                                                  isCorrect: false,
                                                },
                                              ],
                                            }
                                          : que
                                      ),
                                    };
                                  });
                                  setSelectedOption('video');
                                  setOptionTypes('video');
                                }}
                              >
                                video
                              </a>
                            </li>
                          )}
                          {optionTypes.includes('audio') && (
                            <li>
                              <a
                                className='dropdown-item cursor'
                                onClick={(e) => {
                                  setQuestions((old) => {
                                    return {
                                      ...old,
                                      questions: old.questions.map((que, i) =>
                                        i === index
                                          ? {
                                              ...que,
                                              options: [
                                                ...que.options,
                                                {
                                                  text: '',
                                                  type: 'audio',
                                                  isCorrect: false,
                                                },
                                              ],
                                            }
                                          : que
                                      ),
                                    };
                                  });
                                  setSelectedOption('audio');
                                  setOptionTypes('audio');
                                }}
                              >
                                audio
                              </a>
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                    {question.type === 'mcqs' && isEditing && editing && isMore && (
                      <div
                        style={{
                          cursor: 'pointer',
                          fontFamily: 'Inter',
                          fontSize: '12px',
                          fontWeight: '600',
                          color: 'rgb(74, 69, 64)',
                        }}
                        onClick={() => {
                          setIsEditing(false);
                        }}
                      >
                        Save --{'>'}
                      </div>
                    )}
                  </div>
                )}
              </Fragment>
            ) : (
              ''
            )}
          </div>
        </div>
      </Fragment>
    </div>
  );
};
export default NewQuestion;
